import { createApi } from "@reduxjs/toolkit/query/react";
import { BaseQueryWithReAuth, RF_FW_UPGRADE_TAG_TYPES } from "../utils";
import { rfFirmwareUpgradeEndpoints } from "./endpoints/rfFirmwareUpgrade";

export const hesBaseQuery = BaseQueryWithReAuth({
  baseUrl: `${import.meta.env.VITE_LEGACY_RF_FW_UPGRADE_BASE_URL}/`,
  credentials: "same-origin",
  setHeaders(headers) {
    headers.append("Authorization", localStorage.getItem("hes_token") || "");
    return headers;
  }
});

const rfFWApi = createApi({
  reducerPath: "rfFWApi",
  baseQuery: hesBaseQuery,
  tagTypes: RF_FW_UPGRADE_TAG_TYPES,
  endpoints: (builder) => ({
    ...rfFirmwareUpgradeEndpoints(builder)
  })
});

export const {
  useGetBatchListQuery,
  useFetchBatchDetailsMutation,
  useExecuteFWUpgradeCommandMutation,
  usePrefetch
} = rfFWApi;

export default rfFWApi;
